import AnnualLeasingAmountError from './AnnualLeasingAmountError';
class CrowdfundingPropertyNotFound extends AnnualLeasingAmountError {
    propertyId;
    constructor(propertyId, options) {
        super('CROWDFUNDING_PROPERTY_NOT_FOUND', options);
        this.propertyId = propertyId;
    }
}
export default CrowdfundingPropertyNotFound;
